"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSpring = require("react-spring");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var portalInvitationErrorForm = function portalInvitationErrorForm(_ref) {
  var data = _ref.data;
  var props = (0, _reactSpring.useSpring)({
    transform: 'scale(1)',
    from: {
      transform: 'scale(0.5)',
      width: '128px',
      position: 'relative',
      margin: 'auto'
    },
    config: {
      duration: 1000
    }
  });
  var createTicket = "".concat(ENV.createTicketUrl);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sm:w-1/2 lg:w-1/3 xl:w-1/4 bg-white px-3 flex flex-col text-base rounded"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    height: "36",
    className: "self-center my-10"
  }), /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.svg, {
    style: props
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.CloseCircle, {
    width: "128",
    height: "128",
    className: "mb-10 fill-current self-center"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.error.header.left.failure"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold text-2xl mb-4 text-center"
    }, value);
  }), data['transactionCodeStatus'] === "NOT PRESENT" && data['transactionCode'].length !== 16 && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.portalInvitationError.header.left.condition1"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mb-5 text-center"
    }, value);
  }), data['transactionCodeStatus'] === "NOT PRESENT" && data['transactionCode'].length === 16 && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.portalInvitationError.header.left.condition2"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mb-5 text-center"
    }, value);
  }), data['transactionCodeStatus'] === "ACCEPTED" && data['transactionCode'].length === 16 && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.portalInvitationError.header.left.condition3"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mb-5 text-center"
    }, value);
  }), data['transactionCodeStatus'] === "CANCELED" && data['transactionCode'].length === 16 && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.portalInvitationError.header.left.condition4"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mb-5 text-center"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: createTicket,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "p-2 uppercase underline font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.helpCenter.createTickets"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block w-2/5 text-base text-white font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.confirm.header.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "uppercase text-4xl mb-8"
    }, value);
  })));
};

var _default = portalInvitationErrorForm;
exports["default"] = _default;